
import React from 'react';
import { Navigate } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import 'react-tooltip/dist/react-tooltip.css'
import './themes/lokapp/theme.min.css';
import 'primeicons/primeicons.css';


import ErrorPage from "./error-page";
import Contact from "./routes/contact";

// routes Templates --
import ClientRoot from "./routes/root-client";
import PublictRoot from "./routes/root-public";
import LocaRoot, { loader as rootLoader, action as rootAction } from "./routes/root";

import LocaIndex, { loader as locaIndexLoader } from "./routes/loca/index";
// Service
import ServicesList, { loader as servicesListLoader } from "./routes/loca/service/list";
import AddService, { action as createServiceAction, loader as createServiceLoader } from "./routes/loca/service/form";
import EditService, { loader as editServiceLoader, action as editServiceAction, } from "./routes/loca/service/form";
import { action as deleteServiceAction } from "./routes/loca/service/delete";
import Service, { loader as serviceLoader } from "./routes/loca/service/index";
// Tool
import ToolLayout, {
    loader as toolLoader,
    detailsLoader as toolDetailsLoader,
    historyLoader as toolHistoryLoader,
    expensesLoader as toolExpensesLoader,
    ToolDetailsPage,
    ToolAssetsPage,
    ToolContractAnnexesPage,
    ToolHistoryPage,
    ToolExpensesPage
} from "./routes/loca/tool/index";
import CreateTool, { loader as createToolLoader, action as createToolAction } from "./routes/loca/tool/form";
import EditTool, { loader as editToolLoader, action as editToolAction, } from "./routes/loca/tool/form";
import WarehousesPage, { loader as warehousesLoader } from "./routes/loca/tool/warehouses";
import MerchandisePage, { loader as merchandiseLoader } from "./routes/loca/tool/merchandise";
import EquipmentGroupsPage, { loader as equipmentGroupsLoader } from "./routes/loca/tool/equipment-groups";
import DeliveryVehiclePage, { loader as deliveryVehicleLoader } from "./routes/loca/tool/delivery-vehicle";
import ToolsList, { loader as toolsListLoader } from "./routes/loca/tool/list";
import ToolsPublicList, { loader as toolsPublicListLoader } from "./routes/loca/tool/list-public";


// Clients
import ClientsList, { loader as clientsListLoader } from "./routes/loca/client/list";
import CreateClient, { loader as createClientLoader, action as createClientAction } from "./routes/loca/client/form";
import EditClient, { loader as editClientLoader, action as editClientAction, } from "./routes/loca/client/form";
import ClientLayout, { loader as clientLoader, ClientDetailsPage, ClientHistoryPage } from "./routes/loca/client/index";

//Expense
import AddExpense, { action as addExpenseAction } from "./routes/loca/expense/add";

// Stripe
import StripeDeposit, { loader as stripeDepositLoader } from "./routes/loca/stripe/deposit";
import StripePayment, { loader as stripePaymentLoader } from "./routes/loca/stripe/payment";
import StripeAdvancePayment, { loader as stripeAdvancePaymentLoader } from "./routes/loca/stripe/advance-payment";
import StripeDepositSuccess, { loader as stripeDepositSuccessLoader } from "./routes/loca/stripe/success";
import StripePaymentSuccess, { loader as stripePaymentSuccessLoader } from "./routes/loca/stripe/payment-success";

import SwitchPayment, { loader as switchPaymentLoader } from "./routes/loca/rental/switch-payment";

import SwitchAdvancedPayment, { loader as switchAdvancedPaymentLoader } from "./routes/loca/rental/switch-advanced-payment";



//SumUp
import SumUpPayment, { loader as sumUpPaymentLoader } from "./routes/loca/sumup/payment";
import SumUpAdvancePayment, { loader as sumUpAdvancePaymentLoader } from "./routes/loca/sumup/advance-payment";

import SumUpPaymentSuccess, { loader as sumUpPaymentSuccessLoader } from "./routes/loca/sumup/payment-success";
import SumUpPaymentError, { loader as sumUpPaymentErrorLoader } from "./routes/loca/sumup/payment-error";
import SumUpPaymentFailed, { loader as sumUpPaymentFailedLoader } from "./routes/loca/sumup/payment-failed";

import StripeRetryAccount, { loader as stripeRetryAccountLoader } from "./routes/loca/stripe/retry";

// Rental
import AddRental, { action as addRentalAction, loader as addRentalLoader, } from "./routes/loca/rental/form";
import Rental, { loader as rentalLoader } from "./routes/loca/rental/index";
import PublicRental, { loader as publicRentalLoader } from "./routes/loca/rental/public";
import AssetPublic, { loader as assetPublicLoader } from "./routes/loca/rental/asset-public";

import EditRental, { loader as editRentalLoader, action as editRentalAction, } from "./routes/loca/rental/form";
import { action as cancelRentalAction } from "./routes/loca/rental/cancel";
import { action as doneRentalAction } from "./routes/loca/rental/done";
import RentalStats, { loader as statsLoader, action as statsAction } from "./routes/loca/stats/index";

import Login from "./routes/loca/user/login";
import Reset from "./routes/loca/user/reset";
import NewPassword, {loader as newPasswordLoader} from "./routes/loca/user/new-password";

import { loader as switchAccountLoader } from "./routes/switch";
import Register, { loader as registerLoader, action as registerAction } from "./routes/loca/user/register";
import RegisterComplementary, { loader as registerComplementaryLoader, action as registerComplementaryAction } from "./routes/loca/user/register-complementary";
import Account, { loader as accountLoader, action as accountAction } from "./routes/account";
import SettingsPage, { loader as settingsLoader, action as settingsAction } from "./routes/settings";
import { loader as logoutloader } from "./routes/loca/user/logout";

// Admin
import AdminListUsers, { loader as userProfilesListLoader } from "./routes/admin/user/list";
import AdminUserDetails, { loader as userDetailsLoader } from "./routes/admin/user/index";
import AdminUserUpdate, { loader as userUpdateLoader } from "./routes/admin/user/form";
import PendingListings, { loader as pendingListingsLoader } from "./routes/admin/listing/pending";
import ValidatedListings, { loader as validatedListingsLoader } from "./routes/admin/listing/validated";
import AdminListingMapPage, { loader as adminListingMapLoader } from "./routes/admin/listing/map";
import AdminStatsPage, { loader as adminStatsLoader } from "./routes/admin/stats/index";
import AdminQrScansPage, { loader as adminQrScansLoader } from "./routes/admin/qr-scans/index";
import AdminHomepageToolsPage, { loader as adminHomepageToolsLoader } from "./routes/admin/homepage-tools/index";
import AdminAlloVoisinsMessagesPage, { loader as adminAlloVoisinsMessagesLoader } from "./routes/admin/allovoisins-messages/index";
import AdminAlloVoisinsAutomationPage, { loader as adminAlloVoisinsAutomationLoader } from "./routes/admin/allovoisins-automation/index";
import AdminModerationPage, { loader as adminModerationLoader } from "./routes/admin/moderation/index";
import AdminSatisfactionPage, { loader as adminSatisfactionLoader } from "./routes/admin/satisfaction/index";

// Satisfaction
import PublicSatisfaction, { loader as publicSatisfactionLoader } from "./routes/loca/satisfaction/public";
import ToolSatisfactionPage, { loader as toolSatisfactionLoader } from "./routes/loca/tool/satisfaction";


export default function Routes(props) {

    return [{
            // template parentpublic
            element: <PublictRoot />,
            errorElement: <ErrorPage />,
            children: [
                {
                    path: "/login/switch/:childId",
                    loader: switchAccountLoader,
                },
                {
                    element: <Login />,
                    path: "/login",
                },

                {
                    element: <Reset />,
                    path: "/reset",
                },

                {
                    element: <NewPassword />,
                    path: "/new-password/:email/:token",
                    loader: newPasswordLoader,
                }
                ,
                {
                    element: <Register />,
                    path: "/inscription/",
                    action: registerAction,
                    loader: registerLoader,
                },
                {
                    path: "contact",
                    element: <Contact />,
                    errorElement: <ErrorPage />,
                },
                {
                    path: "mesoutils/:userId",
                    element: <ToolsPublicList />,
                    loader: toolsPublicListLoader,
                    errorElement: <ErrorPage />,
                }
            ],
        },
        {
            path: "/logout",
            loader: logoutloader,
            errorElement: <ErrorPage />,
        },

        {
            path: "/",
            element: <ClientRoot />,
            errorElement: <ErrorPage />,

            children: [
                {
                    path: "outils",
                    element: <ToolsList />,
                    loader: toolsListLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    path: "caution/:rentalId",
                    element: <StripeDeposit />,
                    loader: stripeDepositLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    path: "acompte/stripe/:rentalId",
                    element: <StripeAdvancePayment />,
                    loader: stripeAdvancePaymentLoader
                },
                {
                    path: "acompte/sumup/:rentalId",
                    element: <SumUpAdvancePayment />,
                    loader: sumUpAdvancePaymentLoader
                },
                {
                    path: "paiement/stripe/:rentalId",
                    element: <StripePayment />,
                    loader: stripePaymentLoader
                },
                {
                    path: "paiement/sumup/:rentalId",
                    element: <SumUpPayment />,
                    loader: sumUpPaymentLoader
                }

            ]
        },
        {
            path: "/malocation",
            element: <ClientRoot />,
            children: [
                {
                    // A garder, ancienne URL
                    index: true,
                    path: ":rentalId",
                    element: <PublicRental />,
                    loader: publicRentalLoader,
                    errorElement: <ErrorPage />,
                },
                ]
        },

        {
            // Questionnaire de satisfaction du locataire (lien recu par mail a la fin de la location)
            path: "/avis/:token",
            element: <ClientRoot />,
            errorElement: <ErrorPage />,
            children: [
                {
                    index: true,
                    element: <PublicSatisfaction />,
                    loader: publicSatisfactionLoader,
                    errorElement: <ErrorPage />,
                }
            ]
        },

        {
            path: "/materiel/:customUrl/:assetType",
            element: <ClientRoot />,
            children: [
                {
                    index: true,
                    element: <AssetPublic />,
                    loader: assetPublicLoader,
                    errorElement: <ErrorPage />,
                }
            ]
        },
        {
            path: "/payment",
            element: <ClientRoot />,
            errorElement: <ErrorPage />,

            children: [
                {
                    path: "return/:id",
                    element: <SumUpPaymentSuccess />,
                    loader: sumUpPaymentSuccessLoader

                },
                {
                    path: "error/:id",
                    element: <SumUpPaymentError />,
                    loader: sumUpPaymentErrorLoader

                },
                {
                    path: "failed/:id",
                    element: <SumUpPaymentFailed />,
                    loader: sumUpPaymentFailedLoader
                },


            ]
        },
        {
            path: "/public",
            element: <ClientRoot />,
            errorElement: <ErrorPage />,

            children: [
                {
                    // A garder, ancienne URL
                    index: true,
                    path: "outils/liste",
                    element: <ToolsList />,
                    loader: toolsListLoader,
                },
                {
                    path: "paiement/:rentalId",
                    element: <SwitchPayment />,
                    loader: switchPaymentLoader
                },
                {
                    path: "acompte/:rentalId",
                    element: <SwitchAdvancedPayment />,
                    loader: switchAdvancedPaymentLoader
                },
                {
                    path: "stripe/success",
                    element: <StripeDepositSuccess />,
                    loader: stripeDepositSuccessLoader
                },
                {
                    path: "stripe/payment-success",
                    element: <StripePaymentSuccess />,
                    loader: stripePaymentSuccessLoader
                }

            ]
        },

        {
            path: "/",
            element: <LocaRoot />,
            errorElement: <ErrorPage />,
            loader: rootLoader,
            action: rootAction,
            children: [
                {
                    index: true,
                    element: <LocaIndex />,
                     loader: locaIndexLoader,
                },
                {
                    element: <Account />,
                    path: "moncompte",
                    action: accountAction,
                    loader: accountLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <SettingsPage />,
                    path: "parametres",
                    action: settingsAction,
                    loader: settingsLoader,
                    errorElement: <ErrorPage />,
                },

                {
                    element: <RegisterComplementary />,
                    path: "informations-complementaires",
                    action: registerComplementaryAction,
                    loader: registerComplementaryLoader,
                },
                {
                    element: <RentalStats />,
                    path: "stats/:start/:end",
                    loader: statsLoader,
                    action: statsAction,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminListUsers />,
                    path: "user/list",
                    loader: userProfilesListLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminUserDetails />,
                    path: "user/:userId",
                    loader: userDetailsLoader,
                    errorElement: <ErrorPage />,
                }, {
                    element: <AdminUserUpdate />,
                    path: "user/:userId/modification",
                    loader: userUpdateLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <PendingListings />,
                    path: "annonces/validation",
                    loader: pendingListingsLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <ValidatedListings />,
                    path: "annonces/gestion",
                    loader: validatedListingsLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminStatsPage />,
                    path: "administration/statistiques",
                    loader: adminStatsLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminListingMapPage />,
                    path: "administration/carte-annonces",
                    loader: adminListingMapLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminHomepageToolsPage />,
                    path: "administration/materiel-saison",
                    loader: adminHomepageToolsLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminQrScansPage />,
                    path: "administration/scans-qr",
                    loader: adminQrScansLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminModerationPage />,
                    path: "administration/moderation",
                    loader: adminModerationLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminSatisfactionPage />,
                    path: "administration/satisfaction",
                    loader: adminSatisfactionLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminAlloVoisinsMessagesPage />,
                    path: "administration/messages-allovoisins",
                    loader: adminAlloVoisinsMessagesLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminAlloVoisinsMessagesPage />,
                    path: "administration/messages-allovoisins/:channelId",
                    loader: adminAlloVoisinsMessagesLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AdminAlloVoisinsAutomationPage />,
                    path: "administration/automation-allovoisins",
                    loader: adminAlloVoisinsAutomationLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    path: "administration/plateformes",
                    element: <ServicesList />,
                    loader: servicesListLoader,
                },
                {
                    path: "administration/plateformes/ajout",
                    element: <AddService />,
                    action: createServiceAction,
                    loader: createServiceLoader
                },
                {
                    path: "administration/plateformes/:serviceId/modification",
                    element: <EditService />,
                    loader: editServiceLoader,
                    action: editServiceAction,
                },
                {
                    path: "administration/plateformes/:serviceId",
                    element: <Service />,
                    loader: serviceLoader,
                },
                {
                    path: "administration/plateformes/:serviceId/delete",
                    action: deleteServiceAction,
                    errorElement: <ErrorPage />,
                },
                {
                    element: <AddRental />,
                    path: "ajouter",
                    action: addRentalAction,
                    loader: addRentalLoader,
                    shouldRevalidate: ({ currentUrl, nextUrl, defaultShouldRevalidate }) =>
                        currentUrl.search !== nextUrl.search || defaultShouldRevalidate,
                    errorElement: <ErrorPage />,
                },
                {
                    path: ":rentalId/modifier",
                    element: <EditRental />,
                    loader: editRentalLoader,
                    action: editRentalAction,
                    errorElement: <ErrorPage />,
                },
                {
                    path: ":rentalId",
                    element: <Rental />,
                    loader: rentalLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    path: ":rentalId/cancel",
                    action: cancelRentalAction,
                    errorElement: <ErrorPage />,
                },
                {
                    path: ":rentalId/done",
                    action: doneRentalAction,
                    errorElement: <ErrorPage />,
                },
                {
                    id: "tool-detail",
                    path: "monoutil/:toolId",
                    element: <ToolLayout />,
                    errorElement: <ErrorPage />,
                    loader: toolLoader,
                    // Changer la période de l'historique (?from/&to) ne recharge pas la fiche du matériel.
                    shouldRevalidate: ({ currentUrl, nextUrl, formMethod, defaultShouldRevalidate }) =>
                        !formMethod && currentUrl.pathname === nextUrl.pathname && currentUrl.search !== nextUrl.search
                            ? false
                            : defaultShouldRevalidate,
                    children: [
                        {
                            index: true,
                            element: <Navigate to="details" replace />,
                        },
                        {
                            path: "details",
                            element: <ToolDetailsPage />,
                            loader: toolDetailsLoader,
                        },
                        {
                            path: "assets",
                            element: <ToolAssetsPage />,
                        },
                        {
                            path: "annexes",
                            element: <ToolContractAnnexesPage />,
                        },
                        {
                            path: "historique",
                            element: <ToolHistoryPage />,
                            loader: toolHistoryLoader,
                        },
                        {
                            path: "depenses",
                            element: <ToolExpensesPage />,
                            loader: toolExpensesLoader,
                            children: [
                                {
                                    path: "expense/add",
                                    element: <AddExpense />,
                                    action: addExpenseAction,
                                    errorElement: <ErrorPage />,
                                },
                            ],
                        },
                        {
                            path: "satisfaction",
                            element: <ToolSatisfactionPage />,
                            loader: toolSatisfactionLoader,
                        },
                    ],
                },
                {
                    path: "outils/ajout",
                    element: <CreateTool />,
                    action: createToolAction,
                    loader: createToolLoader,
                },

                {
                    path: "monoutil/:toolId/modification",
                    element: <EditTool />,
                    loader: editToolLoader,
                    action: editToolAction,
                },
                {
                    path: "outils/liste",
                    element: <ToolsList />,
                    loader: toolsListLoader,
                },
                {
                    path: "outils/entrepots",
                    element: <WarehousesPage />,
                    loader: warehousesLoader,
                },
                {
                    path: "outils/marchandises",
                    element: <MerchandisePage />,
                    loader: merchandiseLoader,
                },
                {
                    path: "outils/vehicule-livraison",
                    element: <DeliveryVehiclePage />,
                    loader: deliveryVehicleLoader,
                },
                {
                    path: "outils/materiels-partages",
                    element: <EquipmentGroupsPage />,
                    loader: equipmentGroupsLoader,
                },
                {
                    path: "clients/liste",
                    element: <ClientsList />,
                    loader: clientsListLoader,
                    errorElement: <ErrorPage />,
                },
                {
                    path: "clients/ajout",
                    element: <CreateClient />,
                    action: createClientAction,
                    loader: createClientLoader,
                },
                {
                    path: "clients/:clientId/modification",
                    element: <EditClient />,
                    loader: editClientLoader,
                    action: editClientAction,
                },
                {
                    id: "client-detail",
                    path: "clients/:clientId",
                    element: <ClientLayout />,
                    loader: clientLoader,
                    errorElement: <ErrorPage />,
                    children: [
                        {
                            index: true,
                            element: <Navigate to="details" replace />,
                        },
                        {
                            path: "details",
                            element: <ClientDetailsPage />,
                        },
                        {
                            path: "historique",
                            element: <ClientHistoryPage />,
                        },
                    ],
                },
                {
                    path: "services/liste",
                    element: <ServicesList />,
                    loader: servicesListLoader,
                },
                {
                    path: "services/ajout",
                    element: <AddService />,
                    action: createServiceAction,
                    loader: createServiceLoader
                },

                {
                    path: "services/:serviceId/modification",
                    element: <EditService />,
                    loader: editServiceLoader,
                    action: editServiceAction,
                },
                {
                    path: "services/:serviceId",
                    element: <Service />,
                    loader: serviceLoader,
                },
                {
                    path: "services/:serviceId/delete",
                    action: deleteServiceAction,
                    errorElement: <ErrorPage />,
                },
                {
                    path: "stripe/account/retry",
                    element: <StripeRetryAccount />,
                    loader: stripeRetryAccountLoader
                }

            ]
        },

    ];
 }

       
    
